const initialState = {
  projectsPosted: [],
  projectToPost: {
    titleProject: "",
    descriptionProject: "",
    idService: null,
    budgetProject: 0.00,
    statusProject: "",
    videoPresentationProject: null,
    photosProject: [],
    isProfessionalProject: false,
  },
  loading: false,
  error: false,
};

export default function projectReducer(state = initialState, action) {
  switch (action.type) {
    case 'UPDATE_PROJECT_FIELD':
      return {
        ...state,
        projectToPost: {
          ...state.projectToPost,
          [action.payload.field]: action.payload.value,
        },
      };

    case 'ADD_PROJECT_PHOTO':
      return {
        ...state,
        projectToPost: {
          ...state.projectToPost,
          photosProject: [...state.projectToPost.photosProject, action.payload],
        },
      };

    case 'REMOVE_PROJECT_PHOTO':
      return {
        ...state,
        projectToPost: {
          ...state.projectToPost,
          photosProject: state.projectToPost.photosProject.filter(
            (photo, index) => index !== action.payload
          ),
        },
      };

    case 'SET_PROJECT_VIDEO':
      return {
        ...state,
        projectToPost: {
          ...state.projectToPost,
          videoPresentationProject: action.payload,
        },
      };

    case 'SEND_PROJECT_REQUEST':
      return {
        ...state,
        loading: true,
        error: false,
      };

    case 'SEND_PROJECT_SUCCESS':
      return {
        ...state,
        loading: false,
        error: false,
        projectsPosted: [...state.projectsPosted, action.payload],
        // Reset formulaire après succès
        projectToPost: initialState.projectToPost,
      };

    case 'SEND_PROJECT_FAILURE':
      return {
        ...state,
        loading: false,
        error: true,
      };

    default:
      return state;
  }
}
